import template from './estate-type.jade';
import items from '../../../enums/estate-type';

export default angular
    .module('cian.addForm.estateType', [])
    .directive('cianAfPriceAndDealTermsEstateType', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller(deviceService) {
            'ngInject';

            this.isMobile = deviceService.isMobile;

            this.items = items;
        },
        controllerAs: 'estateType',
        template,
    }))
    .name;
